import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspectRatioContainerComponent } from '@go-modules/components/aspect-ratio-container/aspect-ratio-container.component';

@NgModule({
	declarations: [AspectRatioContainerComponent],
	imports: [CommonModule],
	exports: [AspectRatioContainerComponent]
})
export class AspectRatioContainerModule {}
